import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import {
  cmsPanelsApi,
  collectionsApi,
  marketingApi,
  usersApi,
  productsApi,
  transactionsApi,
  administrationsApi,
  ordersApi,
  customersApi,
  salesApi,
  returnsApi,
  exchangesApi,
  stockCheckApi,
  notificationsApi,
  printingApi,
  analyticsApi,
} from "./api/api";
import printSelectionReducer from "./views/printCenter/state/printSelectionSlice";

const apis = [
  cmsPanelsApi,
  collectionsApi,
  marketingApi,
  usersApi,
  productsApi,
  transactionsApi,
  administrationsApi,
  ordersApi,
  customersApi,
  salesApi,
  returnsApi,
  exchangesApi,
  stockCheckApi,
  notificationsApi,
  printingApi,
  analyticsApi,
];

export const store = configureStore({
  reducer: {
    ...Object.fromEntries(apis.map((api) => [api.reducerPath, api.reducer])),
    // Print Center selection: survives search, filters and navigation.
    printSelection: printSelectionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      apis.map((api) => api.middleware)
    ),
  // devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);

export default store;
